import type { UpdateActionEnum } from './types';

export const ObjectFilterAction = {
  Read: 'Read',
  Write: 'Write',
  Admin: 'Admin',
} as const;
export type ObjectFilterAction = (typeof ObjectFilterAction)[keyof typeof ObjectFilterAction];

/**
 * Restricts an API key permission action to a specific MarketAccount.
 * Unrestricted access is represented by an empty or absent `ObjectFilters` array on the API key, not by an empty filter.
 */
export interface ObjectFilter {
  Action: ObjectFilterAction;
  MarketAccount: string;
}

export interface CustomerUserApiKey {
  Timestamp: string;
  CustomerUserApiKeyID: string;
  ApiKey: string;
  UpdateAction: UpdateActionEnum;
  CustomerUserID: string;
  ApiSecret?: string;
  Label?: string;
  WhitelistedIps?: string;
  ObjectFilters?: ObjectFilter[];
}

export function toCreateCustomerUserApiKeyRequestBody(label?: string): { Label: string } | null {
  const trimmed = label?.trim() ?? '';
  return trimmed === '' ? null : { Label: trimmed };
}

function trimmedCustomerUserApiKeyLabel(key: Pick<CustomerUserApiKey, 'Label'>): string {
  return key.Label?.trim() ?? '';
}

/** Primary selector line: Label when set, otherwise the API key. */
export function getCustomerUserApiKeyDisplayLabel(key: Pick<CustomerUserApiKey, 'ApiKey' | 'Label'>): string {
  const label = trimmedCustomerUserApiKeyLabel(key);
  return label === '' ? key.ApiKey : label;
}

/** Second selector line: the API key, omitted when it would duplicate the primary line. */
export function getCustomerUserApiKeyDisplayDescription(
  key: Pick<CustomerUserApiKey, 'ApiKey' | 'Label'>
): string | undefined {
  return trimmedCustomerUserApiKeyLabel(key) === '' ? undefined : key.ApiKey;
}

export interface CustomerUserApiKeyPermissionsUpdate {
  Insert?: string[];
  Remove?: string[];
  InsertObjectFilters?: ObjectFilter[];
  RemoveObjectFilters?: ObjectFilter[];
}
